export default {
  style: {
    width: '100%'
  },
  rowKey: 'id', // 行 unique key
  defaultExpandAll: false, // 是否默认展开行
  showSummary: false, // 是否展示展开行
  columns: [{ title: '暂无表头' }], // 表格列配置

  lazy: true, // 树表格是否懒加载
  load: (tree, treeNode, resolve) => {}, // 树表格懒加载方法
  treeProps: { // 树表格默认属性
    children: 'children',
    hasChildren: 'hasChildren'
  },
  cellClassName: () => {},
  arraySpanMethod: () => {},
  border: false, // 是否显示边框
  page: {
    total: 0,
    currentPage: 1,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100]
  }, // 分页配置
}
